import { SxProps, Theme } from '@mui/material';

export const PROCESS_SELECT_FORM_CONTROL_SX: SxProps<Theme> = {
  width: '100%',
};

export const PROCESS_SELECT_SX: SxProps<Theme> = {
  '& .MuiSelect-select': {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
};

export const PROCESS_MENU_ITEM_SX: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
};

export const PROCESS_LABEL_SX: SxProps<Theme> = {
  fontWeight: 500,
};
